/** Tipos de documento — portal do prestador (isolado do SGC, alimenta as mesmas tabelas) */

export const DOCS_NOTA_FISCAL = [
  { value: 'Nota Fiscal', label: 'Nota fiscal (PDF/XML)' },
  { value: 'Carta de Correção', label: 'Carta de correção' },
  { value: 'Boleto', label: 'Boleto' },
  { value: 'Relatório', label: 'Relatório (pode enviar mais de um)' },
  { value: 'Certidão Negativa', label: 'Certidões negativas' }
];

export const DOCS_PROPOSTA_EDITAL = [
  { value: 'Proposta', label: 'Proposta' },
  { value: 'Contrato Social', label: 'Contrato social e alterações' },
  { value: 'CPF Sócio', label: 'CPF dos sócios representantes' },
  { value: 'RG Sócio', label: 'RG dos sócios representantes' },
  { value: 'Certidão Negativa', label: 'Certidões negativas' },
  { value: 'Documentação Técnica', label: 'Documentação técnica' }
];

export const STATUS_NOTA_PORTAL = {
  pendente: 'Sem nota',
  pendente_contratos: 'Aguardando aprovação (contratos)',
  devolvida_prestador: 'Devolvida — corrigir',
  pendente_avaliacao: 'Em avaliação fiscal',
  pendente_pagamento: 'Aguardando pagamento',
  pago: 'Paga',
  rascunho: 'Rascunho'
};
